import React from 'react'
import { connect } from 'react-redux'

import { SystemError } from '@offerzen/pinata-shame'

import { hideSystemError, clearSystemError } from './reducers'
import { systemErrorVisible, systemErrorMessage } from './selectors'

/**
 * SystemErrorRedux component
 *
 * @param {Object} props
 * @param {number} [props.offsetTop]
 * @param {boolean} [props.visible]
 * @param {string} [props.message]
 * @param {string} [props.className]
 * @param {Function} [props.hide]
 * @param {Function} [props.clear]
 * @param {number} [props.hideTimeout]
 *
 * @returns {JSX.Element}
 */
const SystemErrorRedux = props => <SystemError {...props} />

const mapStateToProps = state => ({
  message: systemErrorMessage(state),
  visible: systemErrorVisible(state),
})

const mapDispatchToProps = {
  hide: hideSystemError,
  clear: clearSystemError,
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemErrorRedux)
